export const zipCodePattern = {
    value: /^[0-9]{5}(?:-[0-9]{4})?$/,
    message: 'Invalid zip code',
}
